
import React from 'react';
import PropTypes from 'prop-types';
import './MobileMenuOverlay.scss';
import { useSelector } from 'react-redux';
import Button from '../components/ui/Button';
import { useEffect } from 'react';
import { PreservedLink as Link } from '../components/ui/PreservedLink';
import mail from '/icons/mail.svg';
import instagram from '/icons/instagram.svg';
import facebook from '/icons/facebook.svg';
import mail_white from '/icons/mail-white.svg'
import instagram_white from '/icons/instagram-white.svg';
import facebook_white from '/icons/facebook-white.svg';
import { useAffiliate } from '../hooks/useAffiliate';
import { useIsPartnerAffiliate } from '../hooks/useIsPartnerAffiliate';
import { useAppNavigate } from '../hooks/useAppNavigate';
import { trackCTA } from '../utils/trackCTA';

function MobileMenuOverlay({ isOpen, onClose, isMobile }) {
  const navigate = useAppNavigate();
  const colorMode = useSelector((state) => state.ui.colorMode);
  const { affiliate, isLoading } = useAffiliate();
  const isPartnerAffiliate = useIsPartnerAffiliate();


  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isOpen]);


  if (!isMobile) return null;

  return (
    <div className={`mobile-menu ${isOpen ? 'open' : ''} ${colorMode}`}>
      <div className='flex flex-col gap-10 p-10'>
        <div className='menu-items flex flex-col gap-5 items-center'>
          {(!isLoading && !isPartnerAffiliate) &&
            <Link to="/#benefits" onClick={onClose}>Benefits</Link>
          }
          <Link to="/customizer" onClick={onClose}>Customizer</Link>
          <Link to="/#how-it-works" onClick={onClose}>How it Works</Link>
          {/* <Link to="/subscriptions" onClick={onClose} >Subscriptions</Link> */}
        </div>

        <div className='flex items-center justify-center mb-5'>
          <div className='flex justify-center items-center gap-10'>
            <a href="https://form.typeform.com/to/rGdA5UOj" target="_blank" className="mb-4">
              <img src={colorMode === 'dark' ? mail_white : mail} alt="" />
            </a>
            <a href="https://www.instagram.com/pettreatink" target="_blank" className="mb-4">
              <img src={colorMode === 'dark' ? instagram_white : instagram} alt="" />
            </a>
            <a href="https://www.facebook.com/PetTreatink" target="_blank" className="mb-4">
              <img src={colorMode === 'dark' ? facebook_white : facebook} alt="" />
            </a>
          </div>
        </div>

        <div className='flex items-center justify-center'>
          <Button
            type="button"
            variant="filled"
            style={{ maxWidth: 'fit-content' }}
            onClick={() => {
              onClose();
              navigate("/customizer");
              trackCTA('Start Personalizing');
            }}
          >
            Start Personalizing
          </Button>
        </div>
      </div>
    </div>
  );
}

MobileMenuOverlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export default MobileMenuOverlay;
